<div class="card__section" id="distributionTable" [formGroup]="form">
    <p class="typography--body" *ngIf="!criteria?.rentalCategoryCode && !criteria?.state">Select a category, state, or both to view shipping charges.</p>
    <p class="typography--body" *ngIf="(shippingCharges$ | async)?.length === 0 && (criteria?.rentalCategoryCode || criteria?.state)">There are no shipping charges.</p>
    <div class="table" role="table" *ngIf="(shippingCharges$ | async)?.length">
        <span role="rowgroup">
            <span class="table__row table__row--header" role="row">
                <span class="table__cell table__cell--align-left" role="columnheader">Category Name</span>
                <span class="table__cell" role="columnheader">Category Code</span>
                <span class="table__cell" role="columnheader">State</span>
                <span class="table__cell" role="columnheader">Standard Ground</span>
                <span class="table__cell" role="columnheader">2nd Day</span>
                <span class="table__cell" role="columnheader">Next Day</span>
            </span>
        </span>
        <div role="rowgroup" formArrayName="shippingChargesData">
            <opus-shipping-charges-table-row [isEditing]="isEditing" [updatingShippingCharges]="updatingShippingCharges" *ngFor="let charge of shippingCharges$ | async; odd as isOdd; last as isLast; let i = index;" [chargeItm]="charge" [isOdd]="isOdd" [isLast]="isLast" [item]="form.controls.shippingChargesData.controls[i]" [relationshipManagerEmail]="relationshipManagerEmail"></opus-shipping-charges-table-row>
        </div>
    </div>
</div>
